// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Wrapper--2jgiq","Hightlight":"Hightlight--35mDB","Button":"Button--1KEky"};